
const list = [
    {
        introduce: "上合峰会AI宣传短视频《合鸣》",
        name: "上合峰会AI宣传短视频《合鸣》",
        text: "广电",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/上合峰会_NSQKtmenpS.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%872_coCYhjzHON.png",
        title: "项目背景",
        content: "科技与传统《合鸣》，相约上合组织天津峰会！随幻科技MBOX数字影棚系统，用独家XR演播算法与AI数字内容生成技术，助力津云新媒体集团，打造虚实相生文化交流盛景，展望和合共生未来图卷！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%873_RTobYnxkXl.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%874_pFocuRbGZe.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "湖南广电山海APP周年直播庆典",
        name: "湖南广电山海APP周年直播庆典",
        text: "广电、文博",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/山海app十周年发布会直播_vqaVgRqMKP.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%875_AvVrLAkNWA.png",
        title: "项目背景",
        content: "赓续文脉，共赴山海！随幻科技助力「山海App」周年直播盛典，将数字内容的AI生成与XR虚拟直播技术融合运用，构建了一个虚实相生的山水画卷。青山绿水之间精卫鸟穿梭而过，嘉宾山间对谈，道尽文化传承与新生，畅想数字文博的广阔前景！观众如临其境，沉浸式感受科技与文化、历史与想象、传承与创新的宏大与浪漫！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%876_zFaStpjNqZ.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20251103/%E5%9B%BE%E7%89%877_yagpELdpgB.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "影游互动剧《代号三国》",
        name: "全国首部全虚拟拍摄互动影游",
        text: "影视游戏",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%871_SiyVMAihEX.png",
        title: "项目背景",
        content: "2025年1月3日，全球首部三国题材权谋爱情真人互动影游《代号三国》正式开机，进入拍摄阶段。《代号三国》由上海玛奇阿朵互娱联合中景文化、沐云听风影业等公司联合出品，随幻科技的MBOX数字化影棚系统，为这一作品提供了全流程的虚拟拍摄技术支持，共同开创了影游互动剧的新篇章。借助随幻科技MBOX数字化影棚系统强大的实时融合渲染能力，《代号三国》将构建出一个高度真实的三国世界。无论是悲壮恢弘的战场厮杀，还是人声鼎沸的古代城池街道，栩栩如生的虚拟场景结合真人的实时融合演出，为玩家带来了前所未有的沉浸式体验，让他们能够更加真实的感受三国时代的氛围与情感，领略到乱世中英雄们的悲欢离合。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%872_QTUWxXcFkc.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%873_wOJkZrpxSA.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "东方明珠“AI 拍”数字旅拍快闪",
        name: "东方明珠“AI 拍”数字旅拍",
        text: "文旅",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/东方明珠AI拍攻略_NqYPLsBRLN.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%877_iRLNMuMBbJ.png",
        title: "项目背景",
        content: "“AI拍”数字旅拍系统，是由随幻科技和上海广电制作共同推出的面向文旅游客体验数字化升级的解决方案。它通过前沿的XR技术，能够结合景区文化特色打造独属的个性化虚拟场景，并将观众带入这一互动体验空间，身临其境地感受历史气息和文化韵味，并获取生动的虚实融合体验和朋友圈打卡传播素材。2025年， “AI拍”数字旅拍系统落地东方明珠0米大厅 ，为上海地标解锁了饱含科技感的全新数字文旅玩法。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%878_fFPsZdcxkc.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250523/%E5%9B%BE%E7%89%879_CleTTExITL.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "《新青年·新经济——青春向新力》五四特别节目",
        name: "央视财经五四特别节目",
        text: "广电媒体",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/央视财经五四特别节目_OfuUtSWAIP.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%871_ftKkURtEWa.png",
        title: "项目背景",
        content: "5月4日《新青年·新经济——青春向新力》五四特别节目中，随幻与科技领域先锋带头人、网红达人、非遗传承人碰出火花！把舞台直接搬进炫酷奇妙的虚拟场景中，见证“新青年”如何解锁他们的新时代的青春密码，展现多姿多彩的青春姿态!本次节目创新搭建三大特色XR舞台让创新绝活亮相未来感十足的科技风舞台传统非遗文化在“数字红枫楼阁”里焕发新生，在轻松露营沙龙氛围中聊创业、谈理想，掀起多彩青春风暴！ 青春不设限，未来正当时！点开视频，一起穿越数字虚拟空间，感受新一代青年的热血与激情吧！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%872_JBlltBjqrU.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%873_AZBDsVfwnz.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "重庆马拉松大直播",
        name: "重庆马拉松",
        text: "文娱",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/金色印象重庆马拉松直播_jTNcjcKqrj.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%874_xyztEIHVYs.png",
        title: "项目背景",
        content: "XR数字技术升级文体直播！3月初2025重庆马拉松热力开跑，随幻科技助力赛事官方支持商#金色印象#以随幻MPRO智能虚拟演播室，为赛事直播注入创新基因：通过XR虚拟融合画面打造“穿越式”观赛体验多维度虚拟场景叠加，助力合作伙伴金色印象实现“直播即营销”的创新传播",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%875_MSCLgqOBWv.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%876_yPYQNnxSlz.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "“爱购物,Ai百联”线上发布会",
        name: "百联美好生活季",
        text: "消费",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/百联发布会_noFbVGESHq.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%879_UCzvTLoUcn.png",
        title: "项目背景",
        content: "4月26日,以“爱购物,Ai百联”为主题的百联美好生活季AI启动仪式酷炫登场，百联集团携手随幻科技，首次以AI智能科技重新定义商业营销场景，精心打造沉浸式线上AI启动仪式直播体验。在这场与百联的深度合作中，随幻科技为百联打造了一个虚实交融的奇幻数字空间：百联IP天团在虚拟舞台上与主持人无缝互动，为营销数字化拓展了更广阔的想象空间，成功实现了线上营销内容的数字化创新，为智慧零售注入了独特的科幻魅力!",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%877_yReUXFHqgQ.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%878_JjSZHfjyOn.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/%E5%9B%BE%E7%89%879_UCzvTLoUcn.png',
        projectHighlights: "暂无",

    },

    {
        introduce: "进博会新闻中心数字化展示",
        name: "第七届进博会新闻中心数字化展示",
        text: "广电媒体",
        imgIcon: "",
        caseVideo: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/jinbohui1_ybfxfERzLq.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/jinbohui1_BhYMXygHwZ.jpg",
        title: "项目背景",
        content: "随11月5日，第七届进博会开幕，随幻科技以“新质生产力”亮相新闻中心，通过裸眼3D、AR插画、动态海报及《悟空的假期》奇幻之旅，为观众带来虚实结合的沉浸式体验。AI+数字科技赋能文化创新，让上海的城市魅力与艺术触手可及，展现了科技赋能文化的无限可能。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/jinbohui2_qWXKZUGOdw.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/jinbohui3_qwZnqUCsSS.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无",

    },

    {
        introduce: "中国人寿《犇腾瑞兽》国风动画",
        name: "中国人寿国风动画",
        text: "金融保险",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/renshou1_GPbpVLVQcq.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/renshou1_ZqRhfmlyxI.png",
        title: "项目背景",
        content: "随幻科技联手新浪财经和中国人寿，打造了一场视觉盛宴——《犇腾瑞兽》国风动画，从策划到制作，满满的都是匠心独运。动画主题紧扣国潮风尚，瑞兽奔腾，寓意吉祥如意，让人眼前一亮，在看动画的同时，就像是在进行一场穿越千年的文化之旅，这不仅仅是一场视觉盛宴，更是一次文化的深度触碰，随幻通过这样一份精美绝伦的动画，为品牌营销打开了新篇章！",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/renshou2_BTQOIIwsYQ.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/renshou3_wnekxepqOY.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无",

    },
    {
        introduce: "无锡发布数字代言人",
        name: "无锡发布数字代言人",
        text: "政企单位",
        imgIcon: "",
        caseVideo: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/wuxi1_ImEipmInyz.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/wuxi1_PjFKZawdpk.jpg",
        title: "项目背景",
        content: "2024中国国际智能传播论坛——“首届AI数字人论坛”中，随幻科技助力央视网，为“无锡发布”数字代言人欢曦打造了惊艳的首秀视频。作为全国首个城市政务发布平台形象数字人，欢曦身上结合了随幻科技的3D超写实数字人技术、多模态融合交互技术与AI自然语言处理技术，共同营造出了一个灵动聪慧又多才多艺的城市代言人形象。这种AI数字人与XR技术融合展现的方式，也为城市文化传播与影响力的打造展开了一条数智化的新思路。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/wuxi2_KrvMPIXtaD.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/wuxi3_sKchWvLpfd.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无",

    },
    {
        introduce: "《史莱姆》手游上线直播",
        name: "《史莱姆新世界》手游上线大直播",
        text: "游戏",
        imgIcon: "",
        caseVideo: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/shouyou1_ULOuAWMliX.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/shouyou1_wEoAwnuQZg.png",
        title: "项目背景",
        content: "随解锁游戏直播新次元！随幻科技携手史莱姆新世界，打造沉浸式AI+XR直播盛宴。在这个前所未有的合作中，随幻科技凭借其、前沿的技术，为史莱姆新世界游戏构建了一个超乎想象的线上虚拟直播空间。观众仿佛穿越时空，置身于游戏内的奇幻世界，与主播及虚拟角色近距离互动，体验前所未有的沉浸感。随幻数字技术的加入，让直播内容更加丰富多元，预示了未来娱乐互动的新趋势。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/shouyou2_MXhGRdazkB.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/shouyou3_GSzSGGHrWP.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无",

    },
    {
        title: "项目背景",
        introduce: "巴黎奥运会快手《冠军来了》直播",
        name: "快手巴黎奥运会《冠军来了》直播节目",
        text: "影视传媒",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/balikuaishou_PgebQElMRL.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/fengmian1_vQlTFRHubG.png",
        // "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/balikuaishou_jMQotZsKXI.png",
        content: "随打造奥运访谈新舞台！随幻科技助力快手在《冠军来了》访谈直播节目中，创新性地利用数字虚拟空间，构建了一个梦幻般的塞纳河访谈舞台。这个舞台融合了XR和AI技术的精髓，实现了真实世界与虚拟空间的无缝对接，真实人物与虚拟角色的精彩互动。观众不仅能近距离沉浸式的感受奥运冠军的风采，还能在虚拟的塞纳河畔，享受一场前所未有的数字科技盛宴！本次新的节目形式也为海内外各类数字内容的制作与呈现提供了更大的想象空间！",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/balikuaishou1_eAYvTnYSpo.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/balikuaishou2_quFemLEKad.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无",
        // projectHighlightsimg2: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20241126/fengmian1_vQlTFRHubG.png",
    },
    {
        title: "项目背景",
        introduce: "星巴克“四点享快乐”品牌专场直播",
        name: "星巴克“四点享快乐”品牌专场直播",
        text: "零售和餐饮行业",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/%E6%98%9F%E5%B7%B4%E5%85%8B_2_JBzzLSeVHH.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/1_pOXFTlxiic.png",
        content: "随幻科技利用前沿的AI与XR技术，助力星巴克打造了“四点享快乐”品牌专场直播，在虚拟世界里，星巴克不仅展现了其独特的品牌调性，还通过随幻虚拟直播工作站，还原了真实晚霞场景，实现了内容制作的数字化创新，为品牌传播增添无限可能，打开了营销数字化的更大想象空间。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/%E6%98%9F%E5%B7%B4%E5%85%8B11_FTbyJytAkH.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/2_NMGyduJIxw.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "伊利QQ星奶粉奥运短片",
        name: "伊利QQ星奶粉奥运短片",
        text: "乳制品加工业",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/QQ%E6%98%9F_v003_kYvYupPKyu.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/4_UrArrbPJxh.png",
        content: "伊利携手随幻科技，精心打造了一支QQ星奶粉奥运短片。这不仅是一场视觉盛宴，更是通过前沿的AI与XR虚拟技术，对健康中国、冠  军精神深刻理解的生动诠释。AI与XR技术的加入，让广告短片不再局限于传统形式，而是以一种前所未有的沉浸式体验，带领观众走进赛场，感   受每一个激动人心的瞬间，用科技赋能体育，以AI+XR引领新风尚。这场视觉与情感的双重盛宴，为品牌数字化营销开启新体验。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/%E4%BC%8A%E5%88%A91_VRyPNXjZgo.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240806/3_ZlAOwVzLvN.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "中微公司年度业绩说明会",
        name: "中微公司年度业绩说明会",
        text: "电子",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240328/中微_cHYUQSsnXZ.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240328/%E5%9B%BE%E7%89%871_EXYMpQhAmW.png",
        content: "由随幻科技为中微公司董事长兼总经理尹志尧博士量身打造的尹总AI数字人形象，代表中微公司在科创板企业年度业绩说明会上精彩亮相。AI数字人+XR现场发布会这一创新性的尝试不仅打破了传统业绩说明会的模式，更是首次在上市公司业绩说明会中使用，引发了业界的广泛关注和一致好评，随幻科技通过先进的技术，将发布会的内容以更丰富、立体、形象的方式呈现在了公众面前，为上市公司业绩说明会提供了新的尝试和启示，也为未来的企业宣传和推广提供了更多的可能性。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240328/%E5%9B%BE%E7%89%872_gTiKStEyct.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240328/%E5%9B%BE%E7%89%873_LiRQKUIYTH.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "东方卫视跨年晚会XR节目《诗·意》《王招君》",
        name: "东方卫视跨年晚会",
        text: "广电媒体",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/Frame%207%402x.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/张若昀《诗·意》_DkPsEjxley.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20250522/52F57ECE-DCDB-433b-8552-B80D539C4D90_TVrNpBXtFB.png",
        content: "随幻科技助力幻维数码，打造了东方卫视跨年晚会XR节目《诗·意》和《王招君》，演员张若昀游荡于山水之中，品味诗意人生，歌手黄龄和虚拟主持人东方媛在虚拟场景中用吴侬软语声声传唱，实现了传统新中式与虚拟科技的梦幻交融。随幻科技用XR虚拟和光影融合等技术，打造了一场传统和流行热烈碰撞的舞台。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%862_jyiMCyXIIX.jpeg",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%863_JIvcaYsipu.jpeg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"

    },
    {
        title: "项目背景",
        introduce: "天宁寺跨年3D Mapping灯光秀",
        name: "天宁寺跨年3D Mapping灯光秀",
        text: "文旅",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/常州天宁寺跨年灯光秀_WTztWogbow.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%A4%A9%E5%AE%81%E5%AF%BA%E8%B7%A8%E5%B9%B41_FDsLcJjRsn.jpeg",
        content: "随幻科技助力常州天宁寺打造了首次3D Mapping灯光秀活动，在保留线下灯光效果的同时又增加了线上AR效果，将虚拟世界的数字信息与现实世界进行融合，实现了线上线下的深度交互效果！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%A4%A9%E5%AE%81%E5%AF%BA%E8%B7%A8%E5%B9%B42_gkylzpiCBg.jpeg",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%A4%A9%E5%AE%81%E5%AF%BA%E8%B7%A8%E5%B9%B43_VDlxqXkgwD.jpeg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "卡伦特XR线上新品发布会",
        name: "卡伦特XR线上新品发布会",
        text: "科技",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/卡伦特发布会_MACjYvFhAc.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%8D%A1%E4%BC%A6%E7%89%B91_ZSoMnvyVvd.jpeg",
        content: "随幻科技助力卡伦特打造了一场线上XR产品发布会，用沉浸式的虚拟效果和舞台级的光影技术，连接了“应云而生 智领未来”的主题，为科技品牌解锁了线上营销新体验！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%8D%A1%E4%BC%A6%E7%89%B92_TJtEGuRLbT.jpeg",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E5%8D%A1%E4%BC%A6%E7%89%B93_WjEygdDPRG.jpeg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "伊利金领冠“春节不打烊”天猫直播",
        name: "伊利金领冠“春节不打烊”天猫直播",
        text: "食品 乳制品",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/伊利金领冠_shwrRKEJKY.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E4%BC%8A%E5%88%A9%E9%87%91%E9%A2%861_CREHsoezzn.jpeg",
        content: "随幻科技助力伊利金领冠天猫旗舰店，在新春期间全案策划落地了连续7天的“春节不打烊”大直播，7天7场主题虚拟直播，在伊利专属“未来虚拟工厂”中直击5个城市5大部门业务现场，取得直播大牌孕婴榜第一的亮眼战绩！",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E4%BC%8A%E5%88%A9%E9%87%91%E9%A2%862_sceCtHcjxg.jpeg",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/%E4%BC%8A%E5%88%A9%E9%87%91%E9%A2%863_EVjfCzfVMt.jpeg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "奇点云线上XR发布会",
        name: "奇点云发布会",
        text: "科技",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/qidian_zxQFMSFPsU.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E5%A5%87%E7%82%B91_GNGWHkrGhE.png",
        content: "随幻科技助力奇点云打造了以“Data@ Future”为主题的线上虚拟XR发布会，发布会中随幻提供了全程的一站式虚拟服务，通过深度虚拟和光影融合等技术，让发布会更具科技感和沉浸感。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E5%A5%87%E7%82%B92_FgLzzpSEiL.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E5%A5%87%E7%82%B93_vFdpAQzroX.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "洋河火箭酒专场带货直播",
        name: "洋河",
        text: "白酒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E6%B4%8B%E6%B2%B3_oCmuDZrHuE.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20240302/yanghe_KQUjvVEezn.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E6%B4%8B%E6%B2%B31_AeDfpSPCbS.png",
        content: "随幻科技助力洋河股份，打造了专属的电商虚拟直播间，把洋河的火箭酒搬到了宇宙太空中互动带货，在直播中用XR虚拟技术带观众一起遨游太空。获得了当晚抖音直播旗舰店榜单第一、白酒类直播榜单第一的成绩。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E6%B4%8B%E6%B2%B32_fkyLXnDHai.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20231227/%E6%B4%8B%E6%B2%B33_geRkmnaNKE.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "优酷《万卷风雅集》融创秀制作",
        name: "优酷",
        text: "文化传媒",
        imgIcon: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230922/%E4%BC%98%E9%85%B7_LNIjpOuRBb.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/万卷风雅集_MOqbOZpveo.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%871_HSwHtlNsQk.png",
        content: "在“国风”“国潮”兴起的当下，文化类节目《万卷风雅集》聚焦文献典籍中的“名场面”，以深入浅出的方式，搭建起文化记忆与当代审美的视听桥梁。随幻科技利用XR虚拟技术将古人笔下的诗词场景化，完美复刻诗情境，带来虚实穿越的沉浸式访古体验。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%872_xvfnmbTVIG.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%873_uWZNnVifXy.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "亚运会官方宣传视频",
        name: "亚运会",
        text: "文化传媒",
        imgIcon: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230922/%E4%BA%9A%E8%BF%90%E4%BC%9A_BMhgCCvqUr.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/亚运会_IhiqQZVUhg.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%874_YbFJdhzpSb.png",
        content: "随幻科技为杭州亚运会打造倒计时宣传片，通过动捕和实时渲染技术将亚运会吉祥物打造栩栩如生，穿梭在不同场馆和杭州代表地标之中，向全世界发出邀请。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%875_OLQUbIfBmT.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%876_IKzNATjaFU.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "龙湖30周年分享会",
        name: "龙湖30周年分享会",
        text: "地产",
        imgIcon: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230922/%E9%BE%99%E6%B9%96_UofnBAswaG.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/地产-龙湖_jVuDnalLoa.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%877_MjnhLzIbIt.png",
        content: "随幻科技助力龙湖地产，打造了一场30周年线上XR发布会，用沉浸式的实时虚拟效果和影视级的虚拟舞台，颠覆了大家对于传统发布会的认知，用创意和科技感连接了“推开一扇门，连接时空轨迹”的主题！",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%878_DgrSaOQIft.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%879_qaSxGnhpzg.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "前晨汽车发布",
        name: "前晨汽车发布",
        text: "汽车",
        imgIcon: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230922/%E5%89%8D%E6%99%A8_TkSDEgOWdP.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/汽车-前景汽车发布会_FGSFKGZnHD.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8710_AkexPacmFD.png",
        content: "随幻科技助力前晨汽车，颠覆规则，引爆未知，打造品牌虚拟线上发布会，定制化的主题场景，将品牌和产品印记刻进了用户脑海，为观众带来了一场汽车发布的视觉盛宴",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8711_BLHKzyIBzD.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8712_JNQlZtqgUZ.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "海辰储能发布会",
        name: "海辰储能发布会",
        text: "新能源",
        imgIcon: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230922/%E6%B5%B7%E8%BE%B0_qduGVRKnPx.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/新能源-海辰储能发布会_jvfMOhpSXA.mp4",
        coverImg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8713_iByJJrCrwh.png",
        content: "海辰储能新品发布会在随幻空间中成功举办，高级质感的发布会舞台、虚拟大屏、AR动画特效配合专业的运镜，让整场发布会效果得到了完美的呈现。",
        serviceContentimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8714_OLKjFOvcjo.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "http://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230919/%E5%9B%BE%E7%89%8715_TeMrvpmjpc.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        title: "项目背景",
        introduce: "Bilibili 2022-2023国创动画片发布会",
        name: "Bilibili",
        text: "文娱｜二次元",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/bilibili.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/2.Bilibili%202022-2023%E5%9B%BD%E5%88%9B%E5%8A%A8%E7%94%BB%E7%89%87%E5%8F%91%E5%B8%83%E4%BC%9A.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/2.Bilibili%202022-2023%E5%9B%BD%E5%88%9B%E5%8A%A8%E7%94%BB%E7%89%87%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        content: "B站国创动画作品发布会于2018年开始，已经连续举办了五届。而与往年不同的是，这届发布会希望采用全线上虚拟的方式进行呈现，虚拟舞台、虚拟特效、虚拟角色，希望凸显未来科技感。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/2.Bilibili%202022-2023%E5%9B%BD%E5%88%9B%E5%8A%A8%E7%94%BB%E7%89%87%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责整场发布会的制作和拍摄，发布会中的AR特效，发布会中穿插数次的转场篇章、场景更迭特效等极大的发挥了动漫特有的想象力。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/2.Bilibili%202022-2023%E5%9B%BD%E5%88%9B%E5%8A%A8%E7%94%BB%E7%89%87%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "直播人气峰值超过1200多万。在随幻科技的技术加持下，本次发布会以“最B站”的方式，在虚拟与现实、抒情与热血间灵活跳转，用XR虚拟技术最大程度还原了国漫的想象力与生命力。"
    },
    {
        title: "项目背景",
        introduce: "Bilibili 2022-2023跨年演唱会",
        name: "Bilibili 2022-2023跨年演唱会",
        text: "文娱传媒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/bilibili.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/30.B站跨年晚会-洛天依跨年全场.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/IMG_3384.JPG.JPG",
        content: "B站跨年晚会2022最美的夜是洛天依时隔两年后再登B站跨年舞台，又恰逢洛天依出道十周年，因此在预热阶段就已经引发了粉丝们的强烈关注，希望打造洛天依在跨年晚会上的视觉盛宴。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/30.Bilibili%20%E8%B7%A8%E5%B9%B4%E6%99%9A%E4%BC%9A-2.JPG",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责从内容到技术的全链条服务，是B站首次将洛天依的表演呈现全部交由国内团队来打造，涉及从模型绑定到布料解算，动捕驱动，AR特效，渲染合成等一系列虚拟技术。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230223/30.Bilibili%202022-2023%E8%B7%A8%E5%B9%B4%E6%99%9A%E4%BC%9A-3.JPG",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "得益于随幻科技对于虚拟领域各个板块技术点的掌握，在年终疫情的极端环境下，以轻量化的团队配置，高质高效完成了整体节目的呈现，让洛天依的表演成为整场晚会最吸睛的部分之一，引发网友热烈讨论。"
    },
    {
        title: "项目背景",
        introduce: "东方卫视2022年中秋晚会",
        name: "东方卫视",
        text: "电视娱乐",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/Frame%207%402x.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/5.1东方卫视2022年中秋晚会-张杰.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/5.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%862022%E5%B9%B4%E4%B8%AD%E7%A7%8B%E6%99%9A%E4%BC%9A-1.png",
        content: "2022年的中秋晚会，晚会希望应用 XR(扩展现实)技术,将传统美学与海派文化巧妙结合。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/5.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%862022%E5%B9%B4%E4%B8%AD%E7%A7%8B%E6%99%9A%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "以XR虚拟技术完成了《苏州河上一座桥》，《但愿人长久》，《天问》等三个节目，充分利用XR技术打破虚实便捷的技术特点，将美好的中秋意象还原。其中致敬中国航天的节目《天问》,收获了人民日报官方微博的点赞。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/5.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%862022%E5%B9%B4%E4%B8%AD%E7%A7%8B%E6%99%9A%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "同时启用了绿幕虚拟制作和LED虚拟制作两种XR虚拟制作方式,两种技术并行使用,最大程度的提高了创意落地的效率。"
    },
    {
        title: "项目背景",
        introduce: "上海时装周元宇宙时尚大秀",
        name: "独立时装设计师品牌JICHENG虚拟时尚大秀",
        text: "时尚行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/3.%E4%B8%8A%E6%B5%B7%E6%97%B6%E8%A3%85%E5%91%A8%E5%85%83%E5%AE%87%E5%AE%99%E6%97%B6.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/3.上海时装周元宇宙时装大秀.mov",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/3.%E4%B8%8A%E6%B5%B7%E6%97%B6%E8%A3%85%E5%91%A8%E5%85%83%E5%AE%87%E5%AE%99%E6%97%B6%E8%A3%85%E5%A4%A7%E7%A7%80-1.png",
        content: "JICHENG品牌在这一季以“羽生万象”为主题，将品牌基因“翅膀”化身多重美学具象",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/3.%E4%B8%8A%E6%B5%B7%E6%97%B6%E8%A3%85%E5%91%A8%E5%85%83%E5%AE%87%E5%AE%99%E6%97%B6%E8%A3%85%E5%A4%A7%E7%A7%80-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻空间为本场元宇宙大秀打造了两个场景，一个是漂浮着巨大羽毛的梦境森林，一个是充满未来感的科技都市，真人与虚拟模特穿梭在两大虚拟T台之上，也正如穿梭在梦境与现实之间。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/3.%E4%B8%8A%E6%B5%B7%E6%97%B6%E8%A3%85%E5%91%A8%E5%85%83%E5%AE%87%E5%AE%99%E6%97%B6%E8%A3%85%E5%A4%A7%E7%A7%80-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "在场景的整体搭建上，纯3D虚拟场景加入超现实元素；真实模特与虚拟模特走秀融合实时光影融合效果"
    },
    {
        title: "项目背景",
        introduce: "美的经销商大会",
        name: "美的",
        text: "家电",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/Frame%207%402x%20(1).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/12.美的经销商大会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/12.%E7%BE%8E%E7%9A%84%E7%BB%8F%E9%94%80%E5%95%86%E5%A4%A7%E4%BC%9A-1.png",
        content: "疫情时代，线上虚拟直播作为品牌首选，美的集团全球新品发布会，聚集了美的全球核心业务领导人、经销商十几万人在线观看。随幻承接了创意设计、特效制作、拍摄管理、过程运营及宣推物料制作。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/12.%E7%BE%8E%E7%9A%84%E7%BB%8F%E9%94%80%E5%95%86%E5%A4%A7%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/12.%E7%BE%8E%E7%9A%84%E7%BB%8F%E9%94%80%E5%95%86%E5%A4%A7%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "全球8国语言同步直播，将发言人置身于浩瀚的元宇宙空间里，并将新产品使用场景做虚拟化渲染，主持人+发言人+产品使用模特多人高频互动，美轮美奂的精切视频，为后续宣推提供物料支持。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "CBRE 无限论坛发布会",
        name: "CBRE 无限论坛发布会",
        text: "地产行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%207%402x%20(2).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/7.CBRE无限论坛.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/7.CBRE%E6%97%A0%E9%99%90%E8%AE%BA%E5%9D%9B%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        content: "以“无限|WE SEE MORE”为主题CBRE世邦魏理仕2022年度论坛在线上召开，品牌通过元宇宙世界观为品牌注入新生机",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/7.CBRE%E6%97%A0%E9%99%90%E8%AE%BA%E5%9D%9B%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "前期方案设计、舞台概念设计、虚拟舞台制作，AR包装制作",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/7.CBRE%E6%97%A0%E9%99%90%E8%AE%BA%E5%9D%9B%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "在随幻科技打造的CBRE“无限宇宙”内，思维领袖、行业先锋和各自的虚拟化身在云端相见，于虚实穿梭之间展望未来商业地产市场趋势。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "易车66购车节潮宇宙汽车夜",
        name: "易次元视界直播",
        text: "汽车行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%207%402x%20(3).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/9.易车66购车节潮宇宙汽车夜.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/9.%E6%98%93%E8%BD%A666%E8%B4%AD%E8%BD%A6%E8%8A%82%E6%BD%AE%E5%AE%87%E5%AE%99%E6%B1%BD%E8%BD%A6%E5%A4%9C-1.png",
        content: "暂无",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/9.%E6%98%93%E8%BD%A666%E8%B4%AD%E8%BD%A6%E8%8A%82%E6%BD%AE%E5%AE%87%E5%AE%99%E6%B1%BD%E8%BD%A6%E5%A4%9C-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "本次活动为观众打造一个汽车世界的破次元幻境，为了凸显这一主旨，随幻科技为易车的本次大直播打造了八大超现实的虚拟场景，特别是为四大汽车品牌打造的四个虚拟星球场景，结合不同车型的风格，分别构建出了中国荣威AI星球、一汽大众JING星球、哈弗YEAH星球和北京现代NEW星球，在贴合品牌调性的同时，呈现出了极致未来感的直播画面。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/9.%E6%98%93%E8%BD%A666%E8%B4%AD%E8%BD%A6%E8%8A%82%E6%BD%AE%E5%AE%87%E5%AE%99%E6%B1%BD%E8%BD%A6%E5%A4%9C-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "这场打破时空与次元、虚实融合的汽车品牌元宇宙直播，在全网获得了超过2600万的观看量，并登上了社交媒体热搜榜，以完美的成绩完成了易车66购车节的收官之战。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "思摩尔新品发布会",
        name: "思摩尔新品发布会",
        text: "消费零售行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/11.%E6%80%9D%E6%91%A9%E5%B0%94%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/11.思摩尔新品发布会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/11.%E6%80%9D%E6%91%A9%E5%B0%94%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        content: "英国高端品牌思摩尔国际（SMOORE）为提供雾化科技解决方案的全球领导者，旗下技术品牌FEELM计划于2022年1月发布公司研发的新品，希望能够用更加具有科技感、未来感的虚拟形式进行整场发布，凸显品牌调性。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/11.%E6%80%9D%E6%91%A9%E5%B0%94%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责了整场虚拟发布会中的虚拟舞台场景制作、嘉宾演讲环节的多个AR特效制作、演讲嘉宾的虚拟融合和多机位虚拟直播运镜等内容。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/11.%E6%80%9D%E6%91%A9%E5%B0%94%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "现代感的虚拟舞台、顺滑流畅的影视级运镜效果、高品质AR动画特效，打造了一场极具科技感与未来感的品牌虚拟发布会。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "庆余年手游发布会",
        name: "庆余年手游发布会",
        text: "游戏行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/16.%E5%BA%86%E4%BD%99%E5%B9%B4%E6%89%8B%E6%B8%B8%E5%8F%91%E5%B8%83%E4%BC%9A.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/16.庆余年手游发布会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/16.%E5%BA%86%E4%BD%99%E5%B9%B4%E6%89%8B%E6%B8%B8%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        content: "暂无",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/16.%E5%BA%86%E4%BD%99%E5%B9%B4%E6%89%8B%E6%B8%B8%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "3月25日，《庆余年》手游全平台上线，随幻科技将《庆余年》本场虚拟发布会搬到了线上交互虚拟空间进行，三大主题场景沉浸式呈现，虚拟“范闲”在直播中与线上网友实时互动，彻底穿越古今打破次元。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/16.%E5%BA%86%E4%BD%99%E5%B9%B4%E6%89%8B%E6%B8%B8%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "本次直播依托 XR 扩展现实技术，一开场便完美再现游戏中古今融合的范若若工作室，配合多机位互动与多角度切换，为大家带来了全场景沉浸式的体验。历时1个多小时的直播，在全网吸引了近千万线上网友观看，并收获了大量好评。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "科大讯飞show AI发布会",
        name: "科大讯飞show AI发布会",
        text: "3C行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/14.%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9Eshow%20AI%E5%8F%91%E5%B8%83%E4%BC%9A.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/14.科大讯飞show AI发布会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/14.%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9Eshow%20AI%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        content: "10月24日，以“AI向新 · 数智万物”为主题的2022科大讯飞全球1024开发者线上举办。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/14.%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9Eshow%20AI%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        serviceContenttitle: "服务内容",
        serviceContent: "讯飞虚拟主持人小颜与多位嘉宾齐聚随幻打造的线上虚拟空间之中，互动畅聊。也带来了“综艺感”满满的全新线上虚拟发布会呈现模式。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/14.%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9Eshow%20AI%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "中欧基金线上论坛",
        name: "中欧基金“相信——对话2022与未来”线上思享论坛",
        text: "金融",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/13.%E4%B8%AD%E6%AC%A7%E5%9F%BA%E9%87%91%E7%BA%BF%E4%B8%8A%E8%AE%BA%E5%9D%9B.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/13.中欧基金虚拟直播.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/13.%E4%B8%AD%E6%AC%A7%E5%9F%BA%E9%87%91%E7%BA%BF%E4%B8%8A%E8%AE%BA%E5%9D%9B-1.png",
        content: "暂无",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/13.%E4%B8%AD%E6%AC%A7%E5%9F%BA%E9%87%91%E7%BA%BF%E4%B8%8A%E8%AE%BA%E5%9D%9B-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "中欧基金在随幻空间中构建了一个仿真的虚拟舞台空间，配合空间内的虚拟大屏和影视级的镜头运动，造就了一种极具未来感与品质感的视觉效果，也彰显了中欧基金本身的品牌专业性与高格调。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/13.%E4%B8%AD%E6%AC%A7%E5%9F%BA%E9%87%91%E7%BA%BF%E4%B8%8A%E8%AE%BA%E5%9D%9B-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "中欧基金总经理刘建平携基金经理曹名长、代云锋、曲径、桑磊，特邀人文学者施展、商业观察家何刚，多位行业领导人共同探讨未来市场发展趋势。除了随幻空间的灵活使用，随幻承接线下接待、场景搭建、后续物料制作等一系列工作。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "亚洲杯会徽发布仪式",
        name: "亚洲杯会徽发布仪式",
        text: "体育",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/%E9%9A%8F%E5%B9%BB.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/足联亚洲杯揭幕仪式实景AR水印.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/34.%E4%BA%9A%E6%B4%B2%E6%9D%AF-1.jpg",
        content: "2023年亚洲杯赛事理念是“团结、共享、激情、卓越”，发布时也恰逢上海浦东足球场的揭幕仪式，主办方希望通过不一样的科技方式呈现。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/34.%E4%BA%9A%E6%B4%B2%E6%9D%AF-2.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技采用虚拟AR技术，将足联亚洲杯揭幕仪式开场以“虚拟足球”为元素，实景AR的形式展现揭幕仪式和会徽发布。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/34.%E4%BA%9A%E6%B4%B2%E6%9D%AF-3.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "回到大婚那一天",
        name: "回到大婚那一天",
        text: "剧集",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%207%402x%20(4).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/回到大婚那一天 水印版.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/35.%E5%A4%A7%E5%A9%9A-1.png",
        content: "当下的虚拟场景技术还是无法达到实景拍摄的真实感，但从置景成本考虑，美术部门制作一个场景，可能就需要花掉几个短剧项目的全部成本。换成虚拟场景，则完全可以实现“一键换装”，用最低成本实现无限场景转换。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/35.%E5%A4%A7%E5%A9%9A-2.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "服务内容：通过随幻科技首度尝试全程使用虚拟场景制作，将演员棚内表演通过实时跟踪系统、实时渲染技术，合成后期各个场景，最大限度缩减成本、缩短工期，在短剧行业史上，这几乎是里程碑式的进步。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/35.%E5%A4%A7%E5%A9%9A-3.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "YVR新品发布会",
        name: "YVR新品发布会",
        text: "科技",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/yvr.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/YVR发布会水印版.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/36.YVR-1.jpg",
        content: "YVR整场发布会直播以虚拟发布会形式进行，在随幻科技实时虚拟技术的助力下，为线上观众呈现出了一场颇具科技美感和未来趣味的虚拟发布会。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/36.YVR-2.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技为YVR本场新品发布会设计了两个场景，主场景是最符合电子产品品牌调性的极简黑色空间，第二个场景则是直接复刻了YVR 2设备中的home主界面：行驶在银河中的一艘宇宙飞船。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/36.YVR-3.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "一念逍遥2周年XR音乐会",
        name: "一念逍遥2周年XR音乐会",
        text: "游戏",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/%E4%B8%80%E5%BF%B5%E9%80%8D%E9%81%A5icon.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/34.一念逍遥2周年XR音乐会(1).mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/%E4%B8%80%E5%BF%B5%E9%80%8D%E9%81%A51%20(1).png",
        content: "YVR整场发布会直播以虚拟发布会形式进行，在随幻科技实时虚拟技术的助力下，为线上观众呈现出了一场颇具科技美感和未来趣味的虚拟发布会。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/%E4%B8%80%E5%BF%B5%E9%80%8D%E9%81%A52%20(1).png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技为YVR本场新品发布会设计了两个场景，主场景是最符合电子产品品牌调性的极简黑色空间，第二个场景则是直接复刻了YVR 2设备中的home主界面：行驶在银河中的一艘宇宙飞船。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230227/%E4%B8%80%E5%BF%B5%E9%80%8D%E9%81%A53.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "钉钉酷应用新品发布会",
        name: "钉钉酷应用新品发布会",
        text: "在线软件",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/17.%E9%92%89%E9%92%89%E9%85%B7%E5%BA%94%E7%94%A8%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/17.钉钉酷应用发布会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/17.%E9%92%89%E9%92%89%E9%85%B7%E5%BA%94%E7%94%A8%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        content: "钉钉新功能发布，希望借本次新功能发布落地元宇宙概念。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/17.%E9%92%89%E9%92%89%E9%85%B7%E5%BA%94%E7%94%A8%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责发布会场景的构建，在随幻空间软件场景库中某一既有场景模板基础上打造钉钉动态元素，在满足直播实际功能需求的同时，还兼具了品牌元素的呈现和品质的保证。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/17.%E9%92%89%E9%92%89%E9%85%B7%E5%BA%94%E7%94%A8%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "通过随幻空间仅用一周时间就让钉钉的首场元宇宙直播从想法到落地，获得数十万在线观看，满满好评。随幻空间软件带来的高质高效呈现效果，也让钉钉团队临时“加场”钉钉智能硬件生态服务商峰会，同样取得圆满成功。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "上海市科协“三八”主题活动",
        name: "上海市科协“三八”主题活动",
        text: "政府机关",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/18.上海市科协“三八”主题活动.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/18.%E4%B8%8A%E6%B5%B7%E5%B8%82%E7%A7%91%E5%8D%8F1.png",
        content: "上海市科技系统的本次“三八”国际劳动妇女节以“一起向未来”为主题，“未来感”是贯穿整场活动始终的一大关键词，同时因为活动的初衷是要致敬科技战线的女性，“女性”是活动中的另一大关键词。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/18.%E4%B8%8A%E6%B5%B7%E5%B8%82%E7%A7%91%E5%8D%8F2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "本次活动采用随幻科技的XR实时虚拟技术，将真实人物与虚拟环境相结合，从技术方案，内容策划和视角效果等全程配合。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/18.%E4%B8%8A%E6%B5%B7%E5%B8%82%E7%A7%91%E5%8D%8F3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "呈现一场主题鲜明，科技感强，视角效果惊艳的大型直播活动，收获了热烈的反响，线上网友也纷纷通过弹幕给科技“女神”们送上祝福，同时赞叹这一颠覆性的实时直播方式，带来全新的视听感受。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "卡地亚虚拟直播",
        name: "天猫超级品牌日卡地亚虚拟直播发布会",
        text: "奢侈品品牌、珠宝腕表",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/19.%E5%8D%A1%E5%9C%B0%E4%BA%9A%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/19.卡地亚虚拟直播.mov",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/19.%E5%8D%A1%E5%9C%B0%E4%BA%9A%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-2.png",
        content: "2021年年初，卡地亚隽永风格新品发布，希望能够在天猫官方旗舰店进行一场更具科技含量和未来感的虚拟直播，同时凸显品牌格调。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/19.%E5%8D%A1%E5%9C%B0%E4%BA%9A%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-1.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责了整场直播中的全部虚拟技术部分，包含AR虚拟效果设计、AR虚拟商品制作、虚拟动画特效制作和最终直播执行。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/19.%E5%8D%A1%E5%9C%B0%E4%BA%9A%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "虚拟动画特效与整体品牌调性完美契合；AR虚拟商品制作精美；整体虚拟效果大气流畅，凸显了品牌格调和未来感。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "欧舒丹虚拟直播",
        name: "欧舒丹虚拟直播",
        text: "时尚快消",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/20.%E6%AC%A7%E8%88%92%E4%B8%B9%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/20.欧舒丹虚拟直播.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/20.%E6%AC%A7%E8%88%92%E4%B8%B9%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-3.png",
        content: "全民抗疫期间，品牌营销难度不断增大。预算减少、拍摄受限成为众多品牌营销中的痛点",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/20.%E6%AC%A7%E8%88%92%E4%B8%B9%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "全民抗疫期间，品牌营销难度不断增大。预算减少、拍摄受限成为众多品牌营销中的痛点。随幻科技助力欧舒丹线上虚拟直播，更有人气偶像刘宇来到虚拟直播间，在降本增效的同时，通过新传播形式扩充年轻消费者圈层，提升品牌在年轻人中的好感度。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/20.%E6%AC%A7%E8%88%92%E4%B8%B9%E8%99%9A%E6%8B%9F%E7%9B%B4%E6%92%AD-1.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "新瑞鹏爱宠狂欢节",
        name: "新瑞鹏爱宠狂欢节",
        text: "宠物行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/21.%E6%96%B0%E7%91%9E%E9%B9%8F%E7%88%B1%E5%AE%A0%E7%8B%82%E6%AC%A2%E8%8A%82.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/21.新瑞鹏爱宠狂欢节.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/21.%E6%96%B0%E7%91%9E%E9%B9%8F%E7%88%B1%E5%AE%A0%E7%8B%82%E6%AC%A2%E8%8A%82-2.png",
        content: "9月20日晚，新瑞鹏宠物医疗集团第四届920爱宠狂欢节盛大开幕，客户希望通过这场直播为万千宠物爱好者带来一场虚拟与现实对话的奇幻直播。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/21.%E6%96%B0%E7%91%9E%E9%B9%8F%E7%88%B1%E5%AE%A0%E7%8B%82%E6%AC%A2%E8%8A%82-1.png",
        serviceContenttitle: "服务内容",
        serviceContent: "本场直播的第一个亮点，就是新瑞鹏宠物医疗集团彭永鹤先生以虚拟数字人形象演唱歌曲《Sailing》作为开场。另一大亮点，则是虚拟角色阿闻在整个虚拟场景中与两位医师主播的互动。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/21.%E6%96%B0%E7%91%9E%E9%B9%8F%E7%88%B1%E5%AE%A0%E7%8B%82%E6%AC%A2%E8%8A%82-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "LINE FRIENDS天猫新品发布会",
        name: "Line Friends天猫超级品牌日直播",
        text: "快消行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/22.LINE%20FRIENDS%E5%A4%A9%E7%8C%AB%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/22.LINE friends发布会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/22.LINE%20FRIENDS%E5%A4%A9%E7%8C%AB%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        content: "暂无",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/22.LINE%20FRIENDS%E5%A4%A9%E7%8C%AB%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技助力LINE FRIENDS携手天猫超级直播间，举办了一场极具创新性和前瞻性的虚拟直播。以全新的方式多方位将产品更形象地展示给消费者，与观众在更丰富多元的维度实现直播互动。让消费场景更加生动，丰富。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/22.LINE%20FRIENDS%E5%A4%A9%E7%8C%AB%E6%96%B0%E5%93%81%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "中国日报z世代研究院成立仪式",
        name: "中国日报Z世代研究中心成立发布会",
        text: "政企单位",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/23.中国日报z世代研究院成立仪式.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/23.%E4%B8%AD%E5%9B%BD%E6%97%A5%E6%8A%A5z%E4%B8%96%E4%BB%A3%E7%A0%94%E7%A9%B6%E9%99%A2%E6%88%90%E7%AB%8B%E4%BB%AA%E5%BC%8F-2.png",
        content: "2022年5月27日，中国日报社联合多家知名高校和相关研究机构创立的Z世代研究中心在京成立，成立仪式的虚拟发布会于当天上午9点在多个媒体平台上进行了同步直播。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/23.%E4%B8%AD%E5%9B%BD%E6%97%A5%E6%8A%A5z%E4%B8%96%E4%BB%A3%E7%A0%94%E7%A9%B6%E9%99%A2%E6%88%90%E7%AB%8B%E4%BB%AA%E5%BC%8F-1.png",
        serviceContenttitle: "服务内容",
        serviceContent: "为本场发布会设计了一个颇具未来感和创意的Z世代发布会空间。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/23.%E4%B8%AD%E5%9B%BD%E6%97%A5%E6%8A%A5z%E4%B8%96%E4%BB%A3%E7%A0%94%E7%A9%B6%E9%99%A2%E6%88%90%E7%AB%8B%E4%BB%AA%E5%BC%8F-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "虚拟发布会的空间充满了循环运动的元素，无论是旋转的Z字还是舞台上的流光，都勾画出一种不断变化的、多元的空间；给所有直播观众一种如梦似幻的颠覆性视觉体验。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "喜临门年会",
        name: "喜临门元宇宙线上虚拟年会",
        text: "快消行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/24.%E5%96%9C%E4%B8%B4%E9%97%A8.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/24.喜临门年会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/24.%E5%96%9C%E4%B8%B4%E9%97%A8%E5%B9%B4%E4%BC%9A-1.png",
        content: "喜临门诞生于1984年,是享誉全球的国潮床垫品牌。作为“中国床垫第一股”,在众多领域，喜临门都颇具前瞻性，此次的虚拟年会，喜临门也将视线投向了在虚拟技术领域顶尖的随幻科技，强强联合，将沉淀多年的国牌品质和国际领先的虚拟制作技术相融合。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/24.%E5%96%9C%E4%B8%B4%E9%97%A8%E5%B9%B4%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技作为整场年会的虚拟技术方，为喜临门提供了从策划、拍摄到内容制作执行的一站式服务。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/24.%E5%96%9C%E4%B8%B4%E9%97%A8%E5%B9%B4%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "在双方的通力合作下，最终呈现出了一场精彩纷呈的线上虚拟盛宴，也打造出了国牌年会能够有的全新高度。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "三生（中国）年会",
        name: "三生（中国）年会",
        text: "健康行业",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/25.三生（中国）年会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/25.%E4%B8%89%E7%94%9F%EF%BC%88%E4%B8%AD%E5%9B%BD%EF%BC%89%E5%B9%B4%E4%BC%9A-1.png",
        content: "2022年末，三生（中国）健康产业有限公司迎来18周年盛典，希望年会和周年盛典可以通过元宇宙的方式进行呈现。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/25.%E4%B8%89%E7%94%9F%EF%BC%88%E4%B8%AD%E5%9B%BD%EF%BC%89%E5%B9%B4%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "整场年会由随幻科技一站式打造，以“深根 生耀”为主题，营造出了极具想象力与生机的虚拟自然空间。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/25.%E4%B8%89%E7%94%9F%EF%BC%88%E4%B8%AD%E5%9B%BD%EF%BC%89%E5%B9%B4%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "三生董事长黄金宝携公司高管和事业伙伴，与行业专家、权威教授等，在沉浸式虚拟空间中共襄盛会，也呈现出又一个元宇宙年会的经典案例。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "网络电影《落魄保镖之危机疑云》",
        name: "网络电影《落魄保镖之危机疑云》",
        text: "影视文娱",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/27.网络电影《落魄保镖之危机疑云》.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/27.%E7%BD%91%E7%BB%9C%E7%94%B5%E5%BD%B11.jpg",
        content: "10月12日，由绍兴秀娱网合传媒有限公司出品，杭州好格影业有限公司、金华市大华影视文化传播有限公司、少年派文化传播（北京）有限公司、上海随幻智能科技有限公司、中行海外投资顾问（广州）有限公司联合出品的网络电影《落魄保镖之危机疑云》在腾讯视频和爱奇艺会员首播！作为联合出品方，随幻科技负责影片中前期三维动画预演、虚拟拍摄、三维场景制作及后期特效合成。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/%E4%BF%9D%E9%95%961.JPG",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "奇点奖颁奖典礼",
        name: "奇点奖线上颁奖典礼",
        text: "文化传媒",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/28.奇点奖颁奖典礼.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/28.%E5%A5%87%E7%82%B9%E5%A5%96%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC-1%60.png",
        content: "奇点奖”是全球首个幻想艺术视觉概念开发的专业竞赛项目，也是CG创作者们心中堪比奥斯卡的存在。2022年2月26日，历时八个月的赛事在上海迎来了最终揭晓的时刻。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/28.%E5%A5%87%E7%82%B9%E5%A5%96%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技为首届“奇点奖”颁奖典礼提供了全程虚拟技术与XR虚拟直播支持。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/28.%E5%A5%87%E7%82%B9%E5%A5%96%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "随幻科技的核心技术：带深度XR实时虚拟技术，在此次盛典直播中发挥了重要作用。就算是浩瀚如宇宙的虚拟场景，在带深度XR实时虚拟技术的帮助下，也能流畅地变换不同机位、不同视角，来完美呈现直播中每一个版块的内容。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "芒果TV 《潮音实验室》",
        name: "XR线上演唱会芒果TV 《潮音实验室》",
        text: "电视娱乐",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%207%402x%20(4).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/4.芒果TV 《潮音实验室》虚拟演唱会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/4.%E8%8A%92%E6%9E%9CTV%20%E3%80%8A%E6%BD%AE%E9%9F%B3%E5%AE%9E%E9%AA%8C%E5%AE%A4%E3%80%8B%E8%99%9A%E6%8B%9F%E6%BC%94%E5%94%B1%E4%BC%9A-1.png",
        content: "《潮音实验室》是芒果TV联合随幻科技一起打造的国内首个虚拟直播演唱会厂牌",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/4.%E8%8A%92%E6%9E%9CTV%20%E3%80%8A%E6%BD%AE%E9%9F%B3%E5%AE%9E%E9%AA%8C%E5%AE%A4%E3%80%8B%E8%99%9A%E6%8B%9F%E6%BC%94%E5%94%B1%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "以XR虚拟技术完成了虚拟演唱会从前期的虚拟场景概念设计、场景制作到直播当天的现场执行整体全流程的制作。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/4.%E8%8A%92%E6%9E%9CTV%20%E3%80%8A%E6%BD%AE%E9%9F%B3%E5%AE%9E%E9%AA%8C%E5%AE%A4%E3%80%8B%E8%99%9A%E6%8B%9F%E6%BC%94%E5%94%B1%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "国内首场实时直播的XR线上演唱会，以全虚拟实时直播的形式全程实现十多个场景的无缝对接、八个机位的任意切换、多个特效的准确触发，这些全部是实时直播实现，这不仅是对技术的考验，也要求各部门非常严密的配合。采用了实时深度交互系统。现场通过多机位进行拍摄，通过自研技术将真实世界空间和人物的实时三维深度计算及重建，融合进三维虚拟场景内，再经过实时渲染技术进行画面直播。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "小鹏汽车P7发布会",
        name: "小鹏P7汽车发布会",
        text: "汽车行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%207%402x%20(5).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/6.小鹏汽车P7发布会.mov",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/6.%E5%B0%8F%E9%B9%8F%E6%B1%BD%E8%BD%A6P7%E5%8F%91%E5%B8%83%E4%BC%9A-2.png",
        content: "受疫情环境影响，汽车企业线下的营销活动都改成了线上。但同时，技术和策划上的短板，流程上的生硬照搬，让很多线上活动备受吐槽。因此，小鹏汽车希望能够以一种完全不同的线上发布会方式，来展现小鹏汽车“年轻、会玩”的特点。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/6.%E5%B0%8F%E9%B9%8F%E6%B1%BD%E8%BD%A6P7%E5%8F%91%E5%B8%83%E4%BC%9A-1.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/6%E5%B0%8F%E9%B9%8F%E6%B1%BD%E8%BD%A6P7%E5%8F%91%E5%B8%83%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "真人实时虚拟融合技术与虚拟偶像动捕技术相结合，真人、虚拟舞台、虚拟偶像实现了完美同步与互动，极大增加了线上虚拟发布会的趣味性和未来感。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "PUBG欧洲新年晚会",
        name: "PUBG Mobile",
        text: "游戏行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/Frame%208%402x%20(1).png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/8.PUBG新年晚会.m4v",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/8.PUBG%E6%AC%A7%E6%B4%B2%E6%96%B0%E5%B9%B4%E6%99%9A%E4%BC%9A-1.png",
        content: "PUBG欧洲新年晚会全程XR技术支持。主办方希望通过炫酷的XR技术带玩家们体验游戏经典场景，制作未来感噱头，为玩家们带来惊喜",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/8.PUBG%E6%AC%A7%E6%B4%B2%E6%96%B0%E5%B9%B4%E6%99%9A%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "包括前期方案设计、完成土耳其、西班牙、俄罗斯等四个国家虚拟舞台制作，AR包装制作、动捕数据修复动画制作、及后期合成制作",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/8.PUBG%E6%AC%A7%E6%B4%B2%E6%96%B0%E5%B9%B4%E6%99%9A%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "1、播出效果得到得到主办方认可和游戏玩家一致好评；2、超高难度突破虚实结合的使用边界，实现AI科技、实时数字成像、抠像与反抠像、实时校色等多维呈现"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "扎西平措虚拟MV",
        name: "扎西平措虚拟MV（国内首支虚拟MV）",
        text: "电视娱乐",
        imgIcon: "",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/10.װת־קֶ½´כ׀יִגMV.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/10.%E6%89%8E%E8%A5%BF%E5%B9%B3%E6%8E%AA%E8%99%9A%E6%8B%9FMV-2.png",
        content: "随幻科技联手英伟达等公司一同助力中国新歌声第二季冠军学员扎西平措拍摄国内首支线上实时虚拟MV。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/10.%E6%89%8E%E8%A5%BF%E5%B9%B3%E6%8E%AA%E8%99%9A%E6%8B%9FMV-3.png",
        serviceContenttitle: "服务内容",
        serviceContent: "此MV采用虚幻引擎UE4，动作捕捉系统制作而成，采用虚拟与现实、实时抠像、实时渲染合成的拍摄手法，不限于传统机位，颠覆传统拍摄，空间上无线拓展。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/10.%E6%89%8E%E8%A5%BF%E5%B9%B3%E6%8E%AA%E8%99%9A%E6%8B%9FMV-1.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "不同于传统MV拍摄的高昂成本以及复杂流程，随幻科技的虚拟MV制作筹备周期大幅缩短，现场即实时渲染出片。极大程度降低了成本的同时，也提高了整个团队的制作效率，是国内首次全虚拟拍摄完成的MV。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "芒果TV综艺《遇见馆藏·太空季》",
        name: "芒果TV综艺《遇见馆藏·太空季》",
        text: "影视文娱",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/15.%E8%8A%92%E6%9E%9CTV.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/15.芒果TV综艺《遇见光馆藏・太空季》.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/15.%E8%8A%92%E6%9E%9CTV%E7%BB%BC%E8%89%BA%E3%80%8A%E9%81%87%E8%A7%81%E9%A6%86%E8%97%8F%C2%B7%E5%A4%AA%E7%A9%BA%E5%AD%A3%E3%80%8B-2.png",
        content: "由中国青年报、琦凰文化共同出品，中国航天文创联合出品的文化科普类综艺节目——《遇见馆藏·太空季》旨在传达中国人一直朝着星途宇宙的方向奔涌前进的信念和探索。希望通过虚拟技术让专家学者与明星嘉宾置身于浩瀚的太空世界,身临其境感受无与伦比的互动体验。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/15.%E8%8A%92%E6%9E%9CTV%E7%BB%BC%E8%89%BA%E3%80%8A%E9%81%87%E8%A7%81%E9%A6%86%E8%97%8F%C2%B7%E5%A4%AA%E7%A9%BA%E5%AD%A3%E3%80%8B-1.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/15.%E8%8A%92%E6%9E%9CTV%E7%BB%BC%E8%89%BA%E3%80%8A%E9%81%87%E8%A7%81%E9%A6%86%E8%97%8F%C2%B7%E5%A4%AA%E7%A9%BA%E5%AD%A3%E3%80%8B-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "作为国内首档创新虚拟拍摄的综艺节目,一改传统的拍摄手法,全程采用可视化虚拟摄影棚进行拍摄,充分体现了光学空间定位、实时渲染技术和3D虚拟场景制作的完美融合。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "央视KUA跨越未来科技创新大会",
        name: "央视KUA跨越未来科技创新大会",
        text: "文化传媒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230202/cctv.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230202/32.央视KUA科技创新之夜.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/32.%E5%A4%AE%E8%A7%86KUA%E8%B7%A8%E8%B6%8A%E6%9C%AA%E6%9D%A5%E7%A7%91%E6%8A%80%E5%A4%A7%E4%BC%9A-1.png",
        content: "作为央视开年第一档重磅科技类节目，“酷啊未来 中国科技创新之夜”的创作团队并不想做传统的科技创新的表达，而更希望能有“酷”一点的感觉，因此选择了全XR虚拟形式进行制作和呈现。随幻科技XR虚拟技术全程助力打造，这也是央视新闻频道首个用全XR实时虚拟方式进行制作的科技节目。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/32.%E5%A4%AE%E8%A7%86KUA%E8%B7%A8%E8%B6%8A%E6%9C%AA%E6%9D%A5%E7%A7%91%E6%8A%80%E5%A4%A7%E4%BC%9A-2.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技为节目设计并打造了九大虚拟场景，让演讲者身处这些现实中无法踏足的空间，为科学家们精彩绝伦的演讲内容提供了相得益彰的视觉呈现。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/32.%E5%A4%AE%E8%A7%86KUA%E8%B7%A8%E8%B6%8A%E6%9C%AA%E6%9D%A5%E7%A7%91%E6%8A%80%E5%A4%A7%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "节目在直播当晚吸引了上千万观众的在线观看，以实时虚拟技术展示出的科学的极致浪漫也在社交媒体上引发了热议。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "安徽卫视春晚",
        name: "安徽卫视春晚",
        text: "文化传媒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230202/%E5%AE%89%E5%BE%BD%E5%8D%AB%E8%A7%86.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230202/33.安徽卫视春晚.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/33.%E5%AE%89%E5%BE%BD%E5%8D%AB%E8%A7%86%E6%98%A5%E6%99%9A-3.png",
        content: "今年安徽卫视春晚舞台上选择呈现的是颇具神话色彩的黄梅戏经典选段《天女散花》，并希望通过科技手段打造新视觉。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/33.%E5%AE%89%E5%BE%BD%E5%8D%AB%E8%A7%86%E6%98%A5%E6%99%9A-1.jpg",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技贴合《天女散花》选段的主题，用XR技术打造了一个唯美的月下仙宫场景：徽派建筑、苍松翠柏和一轮明月的掩映下，是悬浮在缥缈云雾中的戏台，更有诸多AR动画特效的加入，为这一传统戏曲节目增添了全新的科技韵味。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/33.%E5%AE%89%E5%BE%BD%E5%8D%AB%E8%A7%86%E6%98%A5%E6%99%9A-2.jpg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "这次随幻科技与安徽卫视联手打造的新视觉黄梅戏节目，从最初的想法萌生到最终的落地播出，全程仅用了一个月的时间。也正是XR实时虚拟技术的一站式高效制作模式和随幻团队的成熟制作经验，保证了节目在极限制作时间内的高质量完成。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "2022IMC上海国际模特大赛数字总决赛",
        name: "2022IMC上海国际模特大赛数字总决赛",
        text: "时尚行业",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/29.2022IMC%E4%B8%8A%E6%B5%B7%E5%9B%BD%E9%99%85%E6%A8%A1%E7%89%B9%E5%A4%A7%E8%B5%9B%E6%95%B0%E5%AD%97%E6%80%BB%E5%86%B3%E8%B5%9B.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230104/29.2022IMC上海国际模特大赛数字总决赛.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/29.2022IMC%E4%B8%8A%E6%B5%B7%E5%9B%BD%E9%99%85%E6%A8%A1%E7%89%B9%E5%A4%A7%E8%B5%9B%E6%95%B0%E5%AD%97%E6%80%BB%E5%86%B3%E8%B5%9B-1.png",
        content: "拥有超过二十年历史的IMC上海国际模特大赛由上海时装周组委会及IMC上海国际模特大赛组委会主办，是中国历史最为悠久的职业模特赛事，大赛主办方一直在努力进行突破和创新，这一次，突破的关键词被选定为了“元宇宙” 。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/29.2022IMC%E4%B8%8A%E6%B5%B7%E5%9B%BD%E9%99%85%E6%A8%A1%E7%89%B9%E5%A4%A7%E8%B5%9B%E6%95%B0%E5%AD%97%E6%80%BB%E5%86%B3%E8%B5%9B-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技为本次大赛打造了三大超现实秀场空间：荒漠中海市蜃楼一般若隐若现的玻璃宫殿、熔岩翻滚的异星上散发荧光的钢铁基地，以及雪山环抱的湖泊中一个延伸至未至之境的步道；超写实虚拟人及交互技术，让数字人模特Mona以灵动逼真的样貌出现在观众前。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/29.2022IMC%E4%B8%8A%E6%B5%B7%E5%9B%BD%E9%99%85%E6%A8%A1%E7%89%B9%E5%A4%A7%E8%B5%9B%E6%95%B0%E5%AD%97%E6%80%BB%E5%86%B3%E8%B5%9B-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "暂无"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "东方卫视2022-2023跨年演唱会",
        name: "东方卫视2022-2023跨年演唱会",
        text: "文化传媒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/Frame%207%402x.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/31.东方卫视跨年晚会-诀爱.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230223/31.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%86%E8%B7%A8%E5%B9%B4%E6%99%9A%E4%BC%9A-1.JPG",
        content: "2022年东方卫视跨年演唱会着力打造一个饱含科技感的舞台，用各种虚实场景之间的变换带给观众全新的视觉体验 。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/31.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%86%E8%B7%A8%E5%B9%B4%E6%99%9A%E4%BC%9A-2.jpeg",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技运用XR实时虚拟技术，在晚会直播现场还原《苍兰诀》中的两大经典场景，实时光影融合算法让虚拟世界的光影无比逼真的投映在真实人物身上。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/31.%E4%B8%9C%E6%96%B9%E5%8D%AB%E8%A7%86%E8%B7%A8%E5%B9%B4%E6%99%9A%E4%BC%9A-3.jpeg",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "本次跨年晚会创下收视的历史新高，并收获多个爆款热搜，《苍兰诀》制作人也发文表示这个特别舞台满足了制作方和粉丝的期待。"
    },
    {
        flag: false,
        title: "项目背景",
        introduce: "Bilibili Macro Link 2021演唱会",
        name: "Bilibili",
        text: "文化传媒",
        imgIcon: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/bilibili.png",
        caseVideo: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/1.Bilibili Macro Link 2021演唱会.mp4",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20221230/1.png",
        content: "BML由B站主办，是ACG人群每年夏天最为重要的线下狂欢之一。B站在2021年的BML上，希望能够使用XR舞台技术来实现更具震撼感的直播效果，同时其官方的虚拟偶像2233娘也计划建造新形象，并在演唱会直播中表演节目。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/1.Bilibili%20Macro%20Link%202021%E6%BC%94%E5%94%B1%E4%BC%9A-2.png",
        serviceContenttitle: "服务内容",
        serviceContent: "随幻科技负责了两大板块内容：一是整个直播表演舞台的全部XR效果，二是B站官方虚拟偶像2233娘的全新形象从平面设计、到模型制作、直至最后的全息直播表演落地执行。",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230208/1.Bilibili%20Macro%20Link%202021%E6%BC%94%E5%94%B1%E4%BC%9A-3.png",
        projectHighlightstitle: "项目亮点",
        projectHighlights: "XR虚拟效果与现实舞台完美匹配，直播效果炸裂；2233娘新怪盗形象设计感强、模型精美；2233娘全息演出制作精良。"
    },
]
export default list